// extracted by mini-css-extract-plugin
module.exports = {"status":"GenericStatus_status__GlrNI"};